
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_1qivf_17zi1_5",
  "description": "awsui_description_1qivf_17zi1_6",
  "body": "awsui_body_1qivf_17zi1_7",
  "icon": "awsui_icon_1qivf_17zi1_8",
  "disabled": "awsui_disabled_1qivf_17zi1_9",
  "button": "awsui_button_1qivf_17zi1_10"
};
  